<template>
  <div>
    <Breadcrumbs
      :breadcrumbs="[
      { title: this.$t(`menu.${serviceSlug}`), disabled: true},
      { title: $t('menu.evohealth/leads'), disabled: true}
    ]">
      <div slot="breadcrumbAfter" class="d-flex align-items-center">

      </div>
    </Breadcrumbs>

    <template v-if="isLoading">
      <div class="overlay-loader"></div>
      <LoadingPlaceholder/>
    </template>

    <va-tabs v-model="tabValue" style="border-width: 2px; margin-bottom: 15px">
      <va-tab v-for="tab in tabViews" :key="tab">
        {{ tab === 'measurements' ? $t("checkup_plus.person.measurements.create.measurements_title") : $t("evohealth.questionnaires.title_pl") }}
      </va-tab>
    </va-tabs>

    <div v-if="tabValue === 0">
      <div class="row evollu-form">
        <div class="col-12 col-md-4">
          <div>
            <label class="form-label">{{$t('evohealth.healthGroup')}}:</label>
            <multiselect
              v-model="filters.healthGroup"
              :options="healthGroups"
              track-by="id"
              label="name"
              :custom-label="val => $t(`evohealth.healthGroups.${val.name}`, val.name)"
              :placeholder="$t('evohealth.healthGroup')"
              select-label=""
              selected-label=""
              deselect-label=""
              :allow-empty="true"
              :multiple="false"
              :searchable="true"
              :disabled="healthGroups.length === 1">
              <template slot="clear">
                <span class="multiselect__clear" v-if="filters.healthGroup !== null"
                      @mousedown.prevent.stop="filters.healthGroup = null; filters.entities = []"></span>
              </template>
            </multiselect>
          </div>
        </div>
      </div>
      <div class="row evollu-form">
        <div class="col-12 col-md-4">
          <label class="form-label">{{ $t('statistics.daterange_created_at') }}</label>
          <RangeDatePicker
            id="date-filter-picker"
            v-model="filters.date"

            :placeholder="$t('optometry.leads.date_range')"/>
        </div>
        <div class="col-12 col-md-4">
          <div>
            <label class="form-label">{{$t('facility.inputs.entity')}}:</label>
            <multiselect
              v-model="filters.entities"
              :options="entitiesOptions"
              track-by="id"
              label="name"
              :custom-label="formatedEntityLabel"
              :placeholder="$t('facility.inputs.entity')"
              select-label=""
              selected-label=""
              deselect-label=""
              :allow-empty="true"
              :multiple="true"
              :searchable="true"
              :disabled="(entitiesOptions.length && entitiesOptions.length === 1) || filters.healthGroup === null">
              <template slot="clear">
                <span class="multiselect__clear" v-if="filters.entities.length > 0"
                      @mousedown.prevent.stop="filters.entities = [];"></span>
              </template>
            </multiselect>
          </div>
        </div>
      </div>

      <div v-if="filters.healthGroup && this.healthParams.length > 0">
        <LeadsTable
          :key="tableKey"
          :componentRef="`${filters.healthGroup.name}EvohealthLeadsTable`"
          :healthParams="healthParams"
          :authorizedEntities="entitiesOptions"
          :filters="filters"
          :columns="leadsTableColumns"
          @leadClicked="onLeadClicked"/>
      </div>
      <BiosignsLeadDetails
        v-if="showBiosignsLeadDetails"
        :selectedLead="selectedLead"
        :healthParams="healthParams"
        @cancel="onLeadDetailCancel"
      />
      <LeadDetails
        v-if="showRegularLeadDetails"
        :healthParams="healthParams"
        :healthGroup="filters.healthGroup"
        :selectedLead="selectedLead"
        @cancel="onLeadDetailCancel"/>
    </div>
    <div v-else>
      <div class="row evollu-form">
        <div class="col-12 col-md-4">
          <label class="form-label">{{ $t('statistics.daterange_created_at') }}</label>
          <RangeDatePicker
            id="date-filter-picker"
            v-model="filters.date"

            :placeholder="$t('optometry.leads.date_range')"/>
        </div>
        <div class="col-12 col-md-4">
          <div>
            <label class="form-label">{{$t('facility.inputs.entity')}}:</label>
            <multiselect
              v-model="filters.anamnesesEntities"
              :options="permittableAnamneseEntities"
              track-by="id"
              label="name"
              :custom-label="formatedEntityLabel"
              :placeholder="$t('facility.inputs.entity')"
              select-label=""
              selected-label=""
              deselect-label=""
              :allow-empty="true"
              :multiple="true"
              :searchable="true"
              :disabled="permittableAnamneseEntities.length === 1">
              <template slot="clear">
                <span class="multiselect__clear" v-if="filters.anamnesesEntities.length > 0"
                      @mousedown.prevent.stop="filters.anamnesesEntities = [];"></span>
              </template>
            </multiselect>
          </div>
        </div>
      </div>
      <div>
        <AnamnesesLeadsTable
          :key="tableKey"
          :componentRef="`AnamnesesEvohealthLeadsTable`"
          :authorizedEntities="permittableAnamneseEntities"
          :filters="filters"
          @leadClicked="onAnamneseLeadClicked"/>
      </div>
    </div>
  </div>

</template>

<script>
import Breadcrumbs from '@/components/common/Breadcrumbs.vue';
import LoadingPlaceholder from '@/components/common/LoadingPlaceholder.vue';
import { AuthEvohealthService } from '@/api/AuthService';
import { EvohealthService } from '@/api/EvohealthService';
import Multiselect from 'vue-multiselect';
import { uniqBy } from 'lodash';
import MultiselectLabelFormatter from '@/mixins/MultiselectLabelFormatter.vue';
import LeadsTable from '@/components/evohealth/leads/LeadsTable.vue';
import RangeDatePicker from '@/components/common/RangeDatePicker.vue';
import BiosignsLeadDetails from '@/components/evohealth/leads/biosigns/LeadDetail.vue';
import LeadDetails from '@/components/evohealth/leads/LeadDetails.vue';
import AnamnesesLeadsTable from '@/components/evohealth/leads/anamneses/AnamnesesLeadsTable.vue';

export default {
  props: {
    serviceSlug: {
      type: String,
      required: true
    }
  },
  mixins: [MultiselectLabelFormatter],
  components: { AnamnesesLeadsTable, LeadDetails, RangeDatePicker, Multiselect, LoadingPlaceholder, Breadcrumbs, LeadsTable, BiosignsLeadDetails },
  data () {
    return {
      tabValue: 0,
      tabViews: ['measurements', 'questionnaires'],
      isLoading: false,
      userPermissions: null,
      healthGroups: [],
      entitiesOptions: [],
      filters: {
        healthGroup: null,
        entities: [],
        anamnesesEntities: [],
        date: {
          start: '',
          end: ''
        }
      },
      healthParams: [],
      selectedLead: null,
      showBiosignsLeadDetails: false,
      showRegularLeadDetails: false,
      tableKey: 0
    }
  },
  async mounted() {
    this.isLoading = true
    try {
      this.userPermissions = await AuthEvohealthService.getUserLeadsPermissions()
      const permittedHealthGroups = [...new Set(this.userPermissions.map(elem => elem.evohealth_health_group_id))]
      this.healthGroups = await EvohealthService.getHealthGroupsByIds(permittedHealthGroups.join(','))
      this.filters.healthGroup = this.healthGroups[0]

    } catch(e) {
      console.log("ERROR: ", e)
      this.showToast(this.$t('agenda.screenings.something_went_wrong'), this.$store.state.errorToastOptions)
    } finally {
      this.isLoading = false
    }

  },
  methods: {
    onLeadClicked: function (selectedLead) {
      this.selectedLead = selectedLead

      if(this.filters.healthGroup.name === 'biosigns_faceheart') {
        this.showBiosignsLeadDetails = true
      } else {
        this.showRegularLeadDetails = true
      }
    },
    onAnamneseLeadClicked: function (selectedLead) {

    },
    onLeadDetailCancel: function () {
      this.showRegularLeadDetails = false
      this.showBiosignsLeadDetails = false
      this.selectedLead = null
    },
  },
  computed: {
    leadsTableColumns: function() {
      const baseColumns = ['createdAt', 'name', 'email', 'mobilePhone', 'entity']
      if(this.filters.healthGroup) {
        switch(this.filters.healthGroup.name){
          case 'biosigns_faceheart':
            baseColumns.push('heartRate','heartRateVariability','systolicBloodPressure','diastolicBloodPressure','respiratoryRate','oxygenSaturation','stressIndex')
            return baseColumns
          case 'BloodPressure':
            baseColumns.push('systolicBloodPressure', 'diastolicBloodPressure', 'heartRate')
            return baseColumns
          case 'BodyTemperature':
            baseColumns.push('temperature')
            return baseColumns
          case 'Glycaemia':
            baseColumns.push('bloodGlucose', 'fasting')
            return baseColumns
          case 'Oximetry':
            baseColumns.push('sessionDuration','minimumOxygenLevel','minimumHeartRate','meanOxygenLevel','meanHeartRate','maximumOxygenLevel','maximumHeartRate')
            return baseColumns
          case 'Spirometry':
            baseColumns.push('FEV1', 'FEV6', 'FEV1/FEV6', 'FEF25-75')
            return baseColumns
          case 'BodyComposition':
            baseColumns.push('weight', 'BMI', 'bodyWater', 'fatMass', 'bodyMuscleMass')
            return baseColumns
          case 'Sarcopenia':
            baseColumns.push('SARC-F', 'gripStrength', 'bodyMuscleMass', 'walkTime');
            return baseColumns;
          case 'Frailty':
            baseColumns.push('exhaustion', 'physicalActivity', 'walkTime', 'gripStrength', 'weightLoss');
            return baseColumns;
          case 'Cholesterol':
            baseColumns.push('totalCholesterol', 'HDLCholesterol', 'LDLCholesterol', 'triglycerides', 'cardiovascularRisk');
            return baseColumns;
          case 'BodyCircumferences':
            baseColumns.push('waist', 'chest', 'abdomen', 'arm', 'calf', 'thigh');
            return baseColumns;
          case 'COPD':
            baseColumns.push('FEV1', 'FEV6', 'FEV1/FEV6', 'FEF25-75', 'FEV1Predicted', 'mMRC', 'exacerbations', 'hospitalizations');
            return baseColumns;
          case 'Urine':
            baseColumns.push('leukocyte', 'nitrite', 'protein', 'glucose', 'blood', 'ketoneBody', 'urobilinogen', 'bilirubin', 'specificGravity', 'pH', 'vitaminC');
            return baseColumns;
          case 'Liver':
            baseColumns.push('AST', 'ALT', 'AST/ALT');
            return baseColumns;
          case 'AcidLactic':
            baseColumns.push('acidLactic');
            return baseColumns;
          case 'Blood':
            baseColumns.push('erythrocytes', 'hematocrit', 'hemoglobin');
            return baseColumns;
          case 'Glucose':
            baseColumns.push('glucose', 'hba1c', 'estimatedAverageGlucose');
            return baseColumns;
          case 'Redox':
            baseColumns.push('FORT', 'FORD', 'redoxIndex', 'uricAcid');
            return baseColumns;
          case 'News2':
            baseColumns.push('finalScoreResult', 'levelOfConsciousness', 'supplementaryOxygenAdministered', 'temperature', 'respiratoryRate', 'oxygenSaturation', 'heartRate', 'sbp');
            return baseColumns;
          default:
            return baseColumns
        }
      }
      return baseColumns
    },
    readAnamnesePermissions: function() {
      let evohealthService = this.$store.state.services.find(service => service.url === this.$store.state.evohealth_server) || null

      if(evohealthService) {
        return evohealthService.user_permissions.filter(perm => perm.access_type >= 1 && perm.info_type === 110)
      }
      return null
    },
    permittableAnamneseEntities: function() {
      const permissions = this.readAnamnesePermissions
      if(permissions.length > 0) {
        let evohealthService = this.$store.state.services.find(service => service.url === this.$store.state.evohealth_server) || null
        if(permissions.some(perm => perm.entity_id === null)) {
          //Is admin, return all
          return evohealthService.entities
        } else {
          const entitiesIds = permissions.map(perm => perm.entity_id)
          return evohealthService.entities.filter(ent => entitiesIds.includes(ent.id))
        }
      }
      return []
    }
  },
  watch: {
    tabValue: function(val) {
      if(val === 1) {
        //this.filters.entities = []
      } else {
        //Handle the filter
      }
    },
    'filters.healthGroup': async function(val) {
      if (val) {
        const consideredPermissions = this.userPermissions.filter(perm => perm.evohealth_health_group_id === parseInt(val.id))
        this.entitiesOptions = uniqBy(consideredPermissions.map(elem => elem.entity), 'id')
        this.healthParams = await EvohealthService.getHealthParamsByGroup(parseInt(val.id))
        if(this.entitiesOptions && this.entitiesOptions.length === 1) {
          this.filters.entities = [this.entitiesOptions[0]]
        }
        ++this.tableKey
      } else {
        this.consideredPermissions = []
        this.filters.healthGroup = null
        this.filters.entities = []
        this.entitiesOptions = []
        this.healthParams = []
      }
    }
  }
};
</script>

<style scoped lang="scss">
.overlay-loader {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  opacity: 0.8;
  filter: blur(5px);
  z-index: 2;
}

.loading-placeholder {
  position: absolute;
  left: 65%;
  right: 50%;
  bottom: 60%;
  top: 40%;
  z-index: 3;
}

:deep(.va-tab:nth-of-type(2)) {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}

:deep(.va-tab:last-of-type) {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}

.va-tab {
  border: 2px solid rgb(41, 196, 169);
}

.va-tab--active {
  background: rgb(41, 196, 169);
  color: white;
}

</style>
